import { initializeChakraComponent } from 'Shared/chakra-initialize';
import initializeComponent from 'Shared/react-initialize';
import { initializeNotificationsService } from 'Shared/Notifications/notification_service';
import { withBreakpointsContext } from 'Shared/utils/breakpoints';
import HeaderInteractive from './header-interactive';
import { MobileAppCartDrawer } from './components/dropdowns/cart_drawer_wrapper';
import './menu-analytics';

initializeNotificationsService();

// HeaderInteractive's workbench drawer opens a device picker that still
// needs Chakra; MobileAppCartDrawer's own tree does not.
initializeChakraComponent('HeaderInteractive', withBreakpointsContext(HeaderInteractive));
initializeComponent('MobileAppCartDrawer', MobileAppCartDrawer);
